import { render, staticRenderFns } from "./userPromotionDialog.vue?vue&type=template&id=48b16b8d&scoped=true&"
import script from "./userPromotionDialog.vue?vue&type=script&lang=js&"
export * from "./userPromotionDialog.vue?vue&type=script&lang=js&"
import style0 from "./userPromotionDialog.vue?vue&type=style&index=0&id=48b16b8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b16b8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48b16b8d')) {
      api.createRecord('48b16b8d', component.options)
    } else {
      api.reload('48b16b8d', component.options)
    }
    module.hot.accept("./userPromotionDialog.vue?vue&type=template&id=48b16b8d&scoped=true&", function () {
      api.rerender('48b16b8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/promotion/components/userPromotionDialog.vue"
export default component.exports